import cn from 'classnames/bind';
import React, { FC, useState, useEffect, useCallback } from 'react';

import { SubtitlesProps, subtitlesRatioValues as SubtitlesRatio } from './Subtitles.types';
import { useSubtitlesSize } from './useSubtitlesSize';
import styles from './Subtitles.module.css';

const newLineRegexp = /\r\n|\n\r|\n|\r/g;

const cx = cn.bind(styles);

const Subtitles: FC<SubtitlesProps> = ({
    offset = { x: 0, y: 0 },
    subtitlesRatio = SubtitlesRatio.NORMAL,
    subtitlesDirection,
    subtitles,
    isSelectEnabled = false,
}) => {
    const { x, y } = offset;
    const [currentSubtitles, setCurrentSubtitles] = useState<string>('');

    useEffect(() => {
        const newCurrentSubtitles = subtitles
            ?.map((subtitle) => subtitle.split(newLineRegexp).join('<br/>'))
            .join('<br/>');

        setCurrentSubtitles(newCurrentSubtitles || '');
    }, [subtitles]);

    const [fontSize, padding] = useSubtitlesSize(subtitlesRatio);

    const stopPropagation = useCallback<React.MouseEventHandler<HTMLDivElement>>(
        (e) => e.stopPropagation(),
        []
    );

    return (
        <div
            style={{
                transform: `translate(${x}px, ${y}px)`,
                fontSize: `${fontSize}px`,
            }}
            className={cx('root', { no_select: !isSelectEnabled })}
            dir={subtitlesDirection}
        >
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
            <div
                className={cx('text')}
                style={{
                    padding: `0 ${padding}px`,
                }}
                onClick={stopPropagation}
                onContextMenu={stopPropagation}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                    __html: currentSubtitles,
                }}
            />
        </div>
    );
};

export default Subtitles;
